import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import moment from 'moment'
import R from 'ramda'
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts'
import StudentCheckinActions from '../../Data/Redux/StudentCheckinRedux'
import Tool from '../../Components/ReportsComponents/Tool'
import CustomizedLegend from '../../Components/ReportsComponents/CustomizedLegend'
import ReportTemplate from './ReportTemplate'
import CentersInfoActions from '../../Data/Redux/CentersInfoRedux'
import StudyProgramsActions from '../../Data/Redux/StudyProgramsRedux'
import CentersExcelActions from '../../Data/Redux/CentersExcelRedux'

const COLORS = ['#152940', '#4B3F72', '#904C77', '#119DA4', '#53A2FF']

class StudentCheckin extends Component {
  constructor(props) {
    super(props)
    this.state = {
      width: 0,
      data: [{ id: '00', hour: '12 AM', total: 0 }, { id: '01', hour: '01 AM', total: 0 }, { id: '02', hour: '02 AM', total: 0 }, { id: '03', hour: '03 AM', total: 0 },
        { id: '04', hour: '04 AM', total: 0 }, { id: '05', hour: '05 AM', total: 0 }, { id: '06', hour: '06 AM', total: 0 }, { id: '07', hour: '07 AM', total: 0 },
        { id: '08', hour: '08 AM', total: 0 }, { id: '09', hour: '09 AM', total: 0 }, { id: '10', hour: '10 AM', total: 0 }, { id: '11', hour: '11 AM', total: 0 },
        { id: '12', hour: '12 PM', total: 0 }, { id: '13', hour: '01 PM', total: 0 }, { id: '14', hour: '02 PM', total: 0 }, { id: '15', hour: '03 PM', total: 0 },
        { id: '16', hour: '04 PM', total: 0 }, { id: '17', hour: '05 PM', total: 0 }, { id: '18', hour: '06 PM', total: 0 }, { id: '19', hour: '07 PM', total: 0 },
        { id: '20', hour: '08 PM', total: 0 }, { id: '21', hour: '09 PM', total: 0 }, { id: '22', hour: '10 PM', total: 0 }, { id: '23', hour: '11 PM', total: 0 }],
    }
  }

  componentWillMount() {
    const { match, activeCenter, getCentersInfo, setCenter, getStudentCheckin, getStudyPrograms } = this.props
    if (this.props.fromCenter) {
      if (match.params) {
        setCenter(match.params.centerId)
        getCentersInfo(match.params.centerId, 'attendance/student-checkin')
        getStudyPrograms(match.params.centerId)
      } else if (activeCenter !== 0) {
        getCentersInfo(activeCenter, 'attendance/student-checkin')
        getStudyPrograms(activeCenter)
      }
    } else {
      getStudentCheckin()
    }
  }

  componentDidMount() {
    this.updateWindowDimensions()
    window.addEventListener('resize', this.updateWindowDimensions)
  }

  componentWillReceiveProps(nextProps) {
    const { studentCheckin, centers, study_programs, fromCenter, centersInfo } = nextProps
    if (studentCheckin && this.state.data.length > 0) {
      const newData = []
      if (this.props.user === 'Director') {
        const keys = Object.keys(studentCheckin)
        keys.sort()
        keys.map((distribution) => {
          if (studentCheckin[distribution]) {
            const selectedHour = this.state.data.find(hour => hour.id === distribution)
            if (selectedHour) {
              if (studentCheckin[distribution].length) {
                Object.keys(studentCheckin[distribution]).map((dtr) => {
                  const newProgram = study_programs.find(s => s.id === studentCheckin[distribution][dtr].study_program_id)
                  if (newProgram) {
                    selectedHour[newProgram.name] = parseFloat(
                    studentCheckin[distribution][dtr].avg_total_students)
                    selectedHour['total'] += parseFloat(
                    studentCheckin[distribution][dtr].avg_total_students)
                  }
                })
              } else {
                const newProgram = study_programs.find(s => s.id === studentCheckin[distribution][dtr].study_program_id)
                selectedHour[newProgram.name] = parseFloat(
                studentCheckin[distribution].avg_total_students)
                selectedHour['total'] += parseFloat(
                studentCheckin[distribution].avg_total_students)
              }
              newData.push(selectedHour)
            }
          } else {
            const selectedHour = this.state.data.find(hour => hour.id === distribution)
            newData.push(selectedHour)
          }
        })
      } else {
        if (!R.isEmpty(studentCheckin)) {
          Object.keys(studentCheckin).map((distribution) => {
            if (studentCheckin[distribution]) {
              const selectedHour = this.state.data.find(hour => hour.id === distribution)
              if (studentCheckin[distribution].length) {
                Object.keys(studentCheckin[distribution]).map((dtr) => {
                  const newCenter = centers.find(c => c.id == studentCheckin[distribution][dtr].center_id)
                  selectedHour[newCenter.abbreviation] = parseFloat(
                  studentCheckin[distribution][dtr].avg_total_students)
                  selectedHour['total'] += parseFloat(
                  studentCheckin[distribution][dtr].avg_total_students)
                })
              } else {
                const newCenter = centers.find(c => c.id == studentCheckin[distribution].center_id)
                selectedHour[newCenter.abbreviation] = parseFloat(
                studentCheckin[distribution].avg_total_students)
                selectedHour['total'] += parseFloat(
                studentCheckin[distribution].avg_total_students)
              }
              newData.push(selectedHour)
            } else {
              const selectedHour = this.state.data.find(hour => hour.id === distribution)
              newData.push(selectedHour)
            }
          })
        }
        if (centersInfo) {
          const keys = Object.keys(centersInfo)
          keys.sort()
          keys.map((distribution) => {
            if (centersInfo[distribution]) {
              const selectedHour = this.state.data.find(hour => hour.id === distribution)
              if (selectedHour) {
                if (centersInfo[distribution].length) {
                  Object.keys(centersInfo[distribution]).map((dtr) => {
                    const newProgram = study_programs.find(s => s.id === centersInfo[distribution][dtr].study_program_id)
                    if (newProgram) {
                      selectedHour[newProgram.name] = parseFloat(
                      centersInfo[distribution][dtr].avg_total_students)
                      selectedHour['total'] += parseFloat(
                      centersInfo[distribution][dtr].avg_total_students)
                    }
                  })
                } else {
                  const newProgram = study_programs.find(s => s.id === centersInfo[distribution][dtr].study_program_id)
                  selectedHour[newProgram.name] = parseFloat(
                  centersInfo[distribution].avg_total_students)
                  selectedHour['total'] += parseFloat(
                  centersInfo[distribution].avg_total_students)
                }
                newData.push(selectedHour)
              }
            } else {
              const selectedHour = this.state.data.find(hour => hour.id === distribution)
              newData.push(selectedHour)
            }
          })
        }
      }
      if (newData.length > 0) {
        this.setState({ data: newData })
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions)
  }

  getBars = () => {
    let bars = null
    if (this.props.user === 'Director' || this.props.fromCenter) {
      bars = this.props.study_programs.map((value, index) => {
        return (
          <Bar key={index} dataKey={value.name} stackId="a" fill={this.pickColor(value.name) ? COLORS[index % COLORS.length] : 'gray'} />
        )
      })
    } else {
      bars = this.props.centers.map((value, index) => {
        return (
          <Bar key={index} dataKey={value.abbreviation} stackId="a" fill={this.pickColor(value.abbreviation) ? COLORS[index % COLORS.length] : 'gray'} />
        )
      })
    }
    return bars
  }

  filter = ({ currentTarget: { id: abbreviation } }) => {
    const newState = { ...this.state }
    const { studentCheckin, centers, study_programs, user } = this.props
    if (user === 'Director') {
      for (let i = 0; i < newState.data.length; i++) {
        if (newState.data[i][abbreviation] && (newState.data[i][abbreviation] !== 0 && newState.data[i][abbreviation] !== null)) {
          newState.data[i][abbreviation] = null
          const { id } = newState.data[i]
          const checkin = studentCheckin[id]
          const newProgram = study_programs.find(c => c.name === abbreviation)
          if (checkin.length) {
            const selectedCheckin = checkin.find(chk => chk.study_program_id === newProgram.id)
            newState.data[i]['total'] -= parseFloat(selectedCheckin.avg_total_students)
          } else {
            newState.data[i]['total'] -= parseFloat(checkin.avg_total_students)
          }
        } else if (newState.data[i][abbreviation] === 0 || newState.data[i][abbreviation] === null) {
          const { id } = newState.data[i]
          const checkin = studentCheckin[id]
          const newProgram = study_programs.find(c => c.name === abbreviation)
          if (checkin.length) {
            const selectedCheckin = checkin.find(chk => chk.study_program_id === newProgram.id)
            newState.data[i]['total'] -= parseFloat(selectedCheckin.avg_total_students)
            newState.data[i][abbreviation] = parseFloat(selectedCheckin.avg_total_students)
            newState.data[i]['total'] += parseFloat(selectedCheckin.avg_total_students)
          } else {
            newState.data[i]['total'] -= parseFloat(checkin.avg_total_students)
            newState.data[i][abbreviation] = parseFloat(checkin.avg_total_students)
            newState.data[i]['total'] += parseFloat(checkin.avg_total_students)
          }
        }
      }
    } else {
      for (let i = 0; i < newState.data.length; i++) {
        if (newState.data[i][abbreviation] && (newState.data[i][abbreviation] !== 0 && newState.data[i][abbreviation] !== null)) {
          newState.data[i][abbreviation] = null
          const { id } = newState.data[i]
          const checkin = studentCheckin[id]
          const newCenter = centers.find(c => c.abbreviation === abbreviation)
          if (checkin.length) {
            const selectedCheckin = checkin.find(chk => chk.center_id === newCenter.id)
            newState.data[i]['total'] -= parseFloat(selectedCheckin.avg_total_students)
          } else {
            newState.data[i]['total'] -= parseFloat(checkin.avg_total_students)
          }
        } else if (newState.data[i][abbreviation] === 0 || newState.data[i][abbreviation] === null) {
          const { id } = newState.data[i]
          const checkin = studentCheckin[id]
          const newCenter = centers.find(c => c.abbreviation === abbreviation)
          if (checkin.length) {
            const selectedCheckin = checkin.find(chk => chk.center_id === newCenter.id)
            newState.data[i]['total'] -= parseFloat(selectedCheckin.avg_total_students)
            newState.data[i][abbreviation] = parseFloat(selectedCheckin.avg_total_students)
            newState.data[i]['total'] += parseFloat(selectedCheckin.avg_total_students)
          } else {
            newState.data[i]['total'] -= parseFloat(checkin.avg_total_students)
            newState.data[i][abbreviation] = parseFloat(checkin.avg_total_students)
            newState.data[i]['total'] += parseFloat(checkin.avg_total_students)
          }
        }
      }
    }
    this.setState(newState)
  }

  pickColor = (name) => {
    let count = 0
    for (let i = 0; i < this.state.data.length; i++) {
      if (this.state.data[i][name] && (this.state.data[i][name] !== 0 && this.state.data[i][name] !== null)) {
        count++
      }
    }
    return count > 0
  }

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth })
  }

  download = () => {
    if (this.props.fromCenter) {
      this.props.getCentersExcel('attendance/student-checkin', this.props.activeCenter)
    } else {
      this.props.getStudentCheckinExcel()
    }
  }

  render() {
    const { studentCheckin, centers, centersInfo, fromCenter } = this.props
    const { width, data } = this.state
    return (
      <ReportTemplate
        title="Distribución Niños"
        date={{ initial: moment().subtract(1, 'months').format('YYYY-MM-DD'), end: moment().format('YYYY-MM-DD') }}
        onClick={this.download}
        loading={!(centers.length > 0 && (studentCheckin['00'] || centersInfo['00']))}
      >
        {centers.length > 0 &&
          <BarChart
            width={width < 763 ? 400 : 648}
            height={width < 763 ? 300 : 400}
            data={data}
            margin={{ top: 40, right: 50, left: 10, bottom: 40 }}
          >
            <CartesianGrid vertical={false} />
            <XAxis dataKey="hour" />
            <YAxis />
            <Tooltip content={<Tool withoutCurrency large />} />
            <Legend content={<CustomizedLegend onClick={!fromCenter && this.filter} />} />
            {this.getBars()}
          </BarChart>
        }
      </ReportTemplate>
    )
  }
}


const mapStateToProps = ({ studentCheckin, centerOptions, auth, study_programs, centersInfo }) => ({
  studentCheckin: studentCheckin.get.results,
  centers: centerOptions.get.results,
  user: auth.user.role,
  study_programs: study_programs.get.results,
  centersInfo: centersInfo.students_checkin.results,
  activeCenter: centersInfo.center,
})

const mapDispatchToProps = dispatch => ({
  getStudentCheckin: () => dispatch(StudentCheckinActions.getRequest({}, true)),
  getStudentCheckinExcel: () => dispatch(StudentCheckinActions.StudentCheckinExcelRequest()),
  getStudyPrograms: centerId => dispatch(StudyProgramsActions.getRequest(centerId)),
  getCentersExcel: (path, centerId) => dispatch(CentersExcelActions.CentersExcelRequest(path, centerId)),
  getCentersInfo: (id, path) => dispatch(CentersInfoActions.getCentersInfoRequest(id, path)),
  setCenter: id => dispatch(CentersInfoActions.setCenter(id)),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(StudentCheckin))



// WEBPACK FOOTER //
// ./src/Containers/Reports/StudentCheckin.jsx